<template>
    <div class="invoice" v-if="registration.id">
        <div class="columns info mb-5">
            <div class="column">
                <div>
                    <p>Below is an invoice for your conference registration. Submit it to your organization to request a purchase order number.</p>

                    <div class="columns mt-4">
                        <div class="column">
                            <b-button type="button" variant="success" @click="print" class="mr-3"><i class="fas fa-print mr-3"></i>Print/PDF</b-button>
                        </div>
                        <div class="column is-6">
                            <b-field>
                                <b-input v-model="url" expanded></b-input>
                                <p class="control">
                                    <b-button class="button is-primary" @click="$copyText(url)">Copy Link</b-button>
                                </p>
                            </b-field>
                        </div>
<!--                        <div class="column is-4">-->

<!--                            <b-field>-->
<!--                                <b-input v-model="emailAddress" placeholder="user@email.com" expanded></b-input>-->
<!--                                <p class="control">-->
<!--                                    <b-button class="button is-primary" :disabled="processing || !emailAddress" @click="email">E-Mail Invoice</b-button>-->
<!--                                </p>-->
<!--                            </b-field>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>


        <div class="invoice-frame content">
            <header>
                <div class="columns">
                    <div class="column is-flex is-justify-content-end is-flex-direction-column">
                        <h4 class="is-align-self-baseline">{{ registration.conference.org }}</h4>
                    </div>
                    <div class="column is-narrow has-text-right" v-if="registration.conference.po_logo">
                        <img :src="registration.conference.po_logo" class="mb-2" style="max-height: 80px;"/>
                    </div>
                </div>
            </header>

            <div class="columns details">
                <div class="column bill-to">
                    <div class="framed">
                        <strong>Bill To</strong>

                        <div class="columns mt-2">
                            <div class="column">
                                {{ registration.po_mail_to }}<br>
                                <span v-if="registration.po_attn_to">ATTN: {{ registration.po_attn_to }}<br></span>
                                {{ registration.po_address_1 }}<span v-if="registration.po_address_2">, {{ registration.po_address_2 }}</span><br>
                                {{ registration.po_city }}, {{ registration.po_state }} &nbsp;{{ registration.po_zip }}<br>
                            </div>
                            <div class="column">
                                <span v-if="registration.po_phone">Phone: {{ registration.po_phone | tel }}<br></span>
                                <span v-if="registration.po_fax">Fax: {{ registration.po_fax | tel }}<br></span>
                                <span v-if="registration.po_email">{{ registration.po_email }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column meta is-4 is-offset-1">
                    <div class="has-text-right mt-2 mb-4"><h3>INVOICE</h3></div>

                    <table>
                        <tr>
                            <th>Invoice #</th>
                            <td>R{{ registration.conference.id }}D{{ registration.id.toString().padStart(4, '0') }}</td>
                        </tr>
                        <tr>
                            <th>Date</th>
                            <td>{{ registration.created_at | moment('MMM D, YYYY') }}</td>
                        </tr>
                        <tr v-if="registration.poNumber">
                            <th>Purchase Order #</th>
                            <td>{{ registration.po_number }}</td>
                        </tr>
                        <tr>
                            <th>Reference Code</th>
                            <td>{{ registration.code }}</td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="columns items">
                <div class="column">
                    <table>
                        <tr>
                            <th>Item</th>
                            <th>Participant</th>
                            <th class="has-text-right">Price</th>
                        </tr>
                        <tr>
                            <td>
                                <div><strong>{{ registration.code }} - {{ registration.reg_type.title }}</strong></div>
                                <div class="sub-title">{{ registration.conference.title }}, {{ registration.conference.start_at | moment('MMM D, YYYY') }} - {{ registration.conference.end_at | moment('MMM D, YYYY') }}</div>
                            </td>
                            <td>{{ registration.first_name }} {{ registration.last_name }}</td>
                            <td class="has-text-right">{{ registration.total_paid | currency }}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <th class="pt-5">Total</th>
                            <th class="pt-5 has-text-right">{{ registration.total_paid | currency }}</th>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="columns mt-5 instructions">
                <div class="column">
                    <div class="framed">
                        <h5>Instructions</h5>
                        <p v-if="registration.conference.po_instructions" v-html="registration.conference.po_instructions"></p>

                        <div class="columns is-gapless">
                            <div class="column is-narrow">
                                <i class="far fa-exclamation-triangle mr-2"></i>
                            </div>
                            <div class="column">
                                Please include reference code ({{ registration.code }}) with purchase order and payments. Combined purchase orders may be accepted however, each participant must have their own my247ed.com account for individualized access to the conference. Check with organizer for bulk payments.
                            </div>
                        </div>

                        <h5 class="mt-4">Submit Purchase Order</h5>

                        <div class="columns">
                            <div class="column">
                                <strong>Mail To:</strong><br>
                                {{ registration.conference.po_mail_to }}<br>
                                <span v-if="registration.conference.po_attn_to">ATTN: {{ registration.conference.po_attn_to }}<br></span>
                                {{ registration.conference.po_address_1 }}<span v-if="registration.conference.po_address_2">, {{ registration.conference.po_address_2 }}</span><br>
                                {{ registration.conference.po_city }}, {{ registration.conference.po_state }} {{ registration.conference.po_zip }}<br>
                            </div>
                            <div class="column" v-if="registration.conference.po_email"><strong>E-Mail To:</strong><br>{{ registration.conference.po_email }}</div>
                            <div class="column" v-if="registration.conference.po_fax"><strong>Fax To:</strong><br>{{ registration.conference.po_fax | tel }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="has-text-centered has-text-grey mt-5" style="font-size: 0.8rem;">
                Generated by my247ed.com
            </div>

        </div>
    </div>
</template>

<script>
    import {client as http} from "../../http_client";
    import async from "async";

    export default {
        components: {},
        props: ['registrationId', 'code'],
        data: function() {
            return {
                registration: {conference: {}},
                emailAddress: '',
                processing: false
            };
        },
        computed: {
            url: function() {
                return 'https://app.my247ed.com/#/invoice/' + this.registrationId + '/' + this.registration.code;
            },
        },
        methods: {
            loadRegistration: function(force) {
                async.series([
                    (cb) => {
                        http.get('app/registrations/' + this.registrationId + '/' + this.code, {force}).then(response => {
                            this.registration = response.data;
                            cb();
                        });
                    },
                ], err => {

                });
            },
            print() {
                window.print();
            },
            email() {
                this.processing = true;
                http.post('app/registrations/' + this.registrationId + '/email', {email: this.emailAddress}).then(response => {
                    window.alert('E-mail has been sent to ' + this.emailAddress);
                    this.emailAddress = '';
                    setTimeout(() => {
                        this.processing = false;
                    }, 5000);
                });
            },
        },
        mounted() {
            this.loadRegistration();
        }
    };
</script>

<style lang="scss" scoped>
    .invoice {
        max-width: 1200px;
        margin: 3rem auto;

        @media print {
            max-width: none;
            margin: 1rem 3rem 0;
        }

        a {
            color: green;
        }

        .info {
            @media print {
                display: none;
            }
        }

        .invoice-frame {
            border: 4px solid #d5d5d5;
            padding: 3rem;
            min-height: 1000px;
            border-radius: 0.5rem;

            @media print {
                border: 0;
                padding: 0;
                margin: 0;
            }

            header {
                border-bottom: 3px solid #333;
                margin-bottom: 2rem;
            }

            .framed {
                border: 1px solid #e7e7e7;
                padding: 1rem;
                border-radius: 5px;
            }

            .details {
                padding-bottom: 2rem;
                margin-bottom: 2rem;

                .bill-to {
                    font-size: 0.9rem;

                    strong {
                        font-size: 1rem;
                    }
                }

                .meta {
                    table {
                        width: 100%;

                        tr {
                            border-bottom: 1px solid #999999;

                            td {
                                text-align: right;
                            }

                            &:last-child {
                                border-bottom: none;
                            }
                        }

                        td, th {
                            border: none !important;
                            padding: 6px 0 !important;
                        }
                    }
                }
            }

            .items {
                table {
                    width: 100%;

                    th {
                        border-bottom: 2px solid #999999;

                    }

                    td {
                        vertical-align: top;
                        border: none !important;

                        .sub-title {
                            font-size: 0.9rem;
                            color: #666;
                        }
                    }
                }
            }

            .instructions {
                font-size: 0.9rem;

                strong {
                    font-size: 1rem;
                }
            }

        }
    }


    body, table, td, a {
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
    }

    table, td {
        mso-table-lspace: 0;
        mso-table-rspace: 0;
    }

    img {
        -ms-interpolation-mode: bicubic;
    }

    table {
        border-collapse: collapse !important;
    }

    body {
        height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
    }

    @media screen and (min-width: 480px) {
        .mw-50 {
            max-width: 50%;
        }
    }

    @media print {
        @page {
            size: auto;
            margin: 0;
        }
        body {
            margin: 1.6cm;
        }
        html {
            margin: 0;
        }
    }

</style>
